module.exports = __webpack_public_path__ + "media/components/assets/img/logo/pks-oslo-f0126bb8da77cac80ef98d9f3e78bbed.png";